import { Box, Card, CardContent, Typography } from "@mui/material";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { useHistory, useLocation } from "react-router-dom";
import { generateGtmEvent } from "../../../Helpers";
import { useContext } from "react";
import { CourseStructureCtx, UserCtx } from "../../../interfaces";
import { UserContext } from "../../../context/UserContext";
import { Role } from "../../../enums";
import { CourseStructureContext } from "../../../context/CourseStructureContext";

export const LeftNavigation = () => {
  const userCtx = useContext(UserContext) as UserCtx;
  const courseStructureCtx = useContext(CourseStructureContext) as CourseStructureCtx;
  const currentCourse = courseStructureCtx.courseTreeStructure?.getCurrentCourse();
  const courseMetadata =
    courseStructureCtx.courseTreeStructure?.getCurrentCourseMetadata();
  let navigationItems = [
    {
      title: "Module Activities",
      icon: <i className="fas fa-book-open-cover"></i>,
      link: "/explore/activities",
      isVisible:
        userCtx.dbUser?.role === Role.teacher ||
        userCtx.dbUser.role === Role.admin ||
        userCtx.dbUser.role === Role.super,
    },
    {
      title: "Browse Videos",
      icon: <GridViewRoundedIcon sx={{ fontSize: "18px" }} />,
      link: "/explore/browse",
      isVisible: !courseMetadata?.explore_page?.disable_browsing_section,
    },
    {
      title: "Saved Videos",
      icon: <BookmarkIcon />,
      link: "/explore/saved",
      isVisible: !courseMetadata?.explore_page?.disable_saved_videos_section,
    },
  ];
  let location = useLocation();
  const history = useHistory();
  const handleNavClick = (path: string) => {
    history.push({
      search: `?courseId=${currentCourse?.id}`,
      pathname: path,
    });
  };

  const HandleDataLayer = (text: string) => {
    generateGtmEvent({
      event: "link",
      action: "click",
      name: "onclick",
      type: "internal link",
      region: "main content",
      section: currentCourse?.name,
      text: text,
    });
  };
  return (
    <>
      {/*<Typography variant="h1">Explore</Typography>*/}
      <Card
        sx={{
          border: "2px solid #DEDEDE",
          borderRadius: "15px",
        }}>
        <CardContent
          sx={{
            padding: "8px",
            "&:last-child": {
              paddingBottom: "8px",
            },
          }}>
          {navigationItems.map((item, index) => {
            if (!item.isVisible) return <> </>;
            return (
              <Box
                tabIndex={0}
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "16px",
                  color: location.pathname === item.link ? "#0092E0" : "",
                  "&:hover": {
                    background: "#F3F3F3 0% 0% no-repeat padding-box",
                    borderRadius: " 8px",
                    color: "#0092E0",
                  },
                }}
                onClick={() => {
                  HandleDataLayer(item.title);
                  handleNavClick(item.link);
                }}>
                {item.icon}
                <Typography variant="h2" component="span" sx={{ fontSize: "1.3125rem" }}>
                  {item.title}
                </Typography>
              </Box>
            );
          })}
        </CardContent>
      </Card>
    </>
  );
};
